import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CustomerService } from '../../../../customer.service';
import { CustomerSharedService } from '../../../../customer-shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceService } from '../../../devices/device.service';
import { CommonService } from '../../../../../../shared/services/common.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import ApexCharts from 'apexcharts';
import { DatePipe } from '@angular/common';



interface Location {
  location_id: string;
  display_name: string;
}

interface Asset {
  asset_name: string;
}

interface Timestamp {
  elapsedTime: number;
  time: string;
}

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-missingReportsForm',
  templateUrl: './missingReportsForm.component.html',
  styles: [],
  providers: [DatePipe]
})
export class MissingReportsFormComponent implements OnInit {
  @ViewChild('chart') chartElement!: ElementRef;
  chart: ApexCharts | null = null;

  public chartOptions: any
  customer_id: string = '';
  locations: any = [];
  assets: any = []
  timestamp: any = []
  missingCount: any = [];
  assetIds: any
  elapsedTimeCount: any = [];
  istTimeStamp: any = []

  selectedLocation?: number;
  selectedAsset: string = '';
  selectedSensorType: string = '';
  deviceeui: string | undefined;
  node: any
  isReportGenerating: boolean = false;
  // Node data

  // Date and time ranges
  dateRange: null = null;

  // Time range: start and end times
  timeRange = {
    start: null,
    end: null,
  };

  uniqueAssets: any = [];

  constructor(private customerService: CustomerService, private customerSharedService: CustomerSharedService,
    private router: Router,
    private route: ActivatedRoute, private deviceService: DeviceService, private commonService: CommonService, private datePipe: DatePipe) {
    this.customer_id = this.route.snapshot.paramMap.get('id') || '';
  }

  ngOnInit() {
    this.getLocationByCustomerId();
  }

  getLocationByCustomerId() {
    this.commonService.getLocationList(Number(this.customer_id)).subscribe({
      next: (response: any) => {
        const locations = Array.isArray(response?.data) ? response.data : [];
        this.locations = locations;
        this.node = Array.from(
          new Set(this.locations?.flatMap((location: any) => location.ancestors))
        );
      },
      error: (err) => {
        console.error('Error fetching locations', err);
        this.commonService.message.error('Failed to fetch locations');
      }
    })
  }

  getAssetByLocation() {
    let obj = {
      location_id: this.selectedLocation
    }

    if (this.selectedLocation) {
      this.deviceService.getAssetByLocation(obj).subscribe((res: any) => {
        if (res?.status === 200) {
          this.assets = res?.data;
          this.assetIds = this.assets.map((asset: any) => asset.asset_id)
        }
      })
    }
  }

  formatDateForAPI(date: Date | null): string {
    if (!date) return '';

    const pad = (num: number) => num.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are 0-based
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  get formattedStartTime(): string {
    if (!this.dateRange?.[0]) return '';
    const datePart = this.formatDateForAPI(this.dateRange[0]);
    const timePart = this.timeRange?.start
      ? this.datePipe.transform(this.timeRange.start, 'HH:mm:ss') || '00:00:00'
      : '00:00:00';
    return `${datePart.split('T')[0]}T${timePart}`;
  }

  get formattedEndTime(): string {
    if (!this.dateRange?.[1]) return '';
    const datePart = this.formatDateForAPI(this.dateRange[1]);
    const timePart = this.timeRange?.end
      ? this.datePipe.transform(this.timeRange.end, 'HH:mm:ss') || '00:00:00'
      : '00:00:00';
    return `${datePart.split('T')[0]}T${timePart}`;
  }

  getCount() {
    this.isReportGenerating = true;

    let obj = {
      startTime: this.formattedStartTime,
      endTime: this.formattedEndTime,
      asset_ids: this.assetIds
    };

    this.customerService.getCount(obj).subscribe(
      (res: any) => {
        this.isReportGenerating = false;
        this.missingCount = res?.data || [];

        if (!Array.isArray(this.missingCount) || this.missingCount.length === 0) {
          this.commonService.message.success('No Readings Missed');
        } else {
          this.renderChart(this.processedData(this.missingCount));
        }
      },
      (error: any) => {
        this.isReportGenerating = false;
        console.error('Error fetching count:', error);
      }
    );
  }

  processedData(data: any) {
    console.log("processData", data);

    const categories: string[] = [];
    const coldSpotCount: number[] = []
    const hotSpotCount: number[] = []
    const neitherCount: number[] = []

    data.forEach((item: any) => {
      categories.push(item.asset_name);
      if (item.sensorType === 'cold spot') {
        coldSpotCount.push(item.count)
        hotSpotCount.push(0)
        neitherCount.push(0)
      } else if
        (item.sensorType === 'hot spot') {
        hotSpotCount.push(item.count)
        coldSpotCount.push(0)
        neitherCount.push(0)
      }
      else {
        neitherCount.push(item.count)
        hotSpotCount.push(0)
        coldSpotCount.push(0)
      }
    });
    return { categories, coldSpotCount, hotSpotCount, neitherCount }
  }

  renderChart(data: any) {
    console.log("renderchart", data.neitherCount);
    console.log(data.categories.length);

    if (this.chart) {
      this.chart.destroy();
    }
    const options = {
      series: [{
        name: 'Cold Spot',
        data: data.coldSpotCount
      },
      {
        name: 'Hot Spot',
        data: data.hotSpotCount,
      },
      {
        name: 'Neither',
        data: data.neitherCount,
      },],
      chart: {
        type: 'bar',
        height: data.categories.length > 3 ? data.categories.length * 80 : 200,
        width: '80%',
        offsetX: 3,
        stacked: true,
      },

      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: "top"
          },
          barHeight: '70%', // Reduced bar height (adjust as needed)
          borderRadius: 4,
          hideZeroBarsWhenGrouped: true,
          columnWidth: '40%',// This helps distribute the bars evenly
        }
      },
      colors: ['#1666ba', 'lightblue', 'gray'],
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: "16px",
          colors: ["#fff"]
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ["#fff"]
      },
      xaxis: {
        categories: data.categories,

      },
      title: {
        text: 'Hotspot and Coldspot Count by Asset',
        align: 'center',
      },
    }

    this.chart = new ApexCharts(document.querySelector('#chart'), options);
    this.chart.render()
  }

  findDeviceEui() {
    const selectedData = this.missingCount.find((dev: any) => {
      console.log(`Comparing asset_name: ${dev.asset_name} with ${this.selectedAsset}`);
      console.log(`Comparing sensorType: ${dev.sensorType} with ${this.selectedSensorType}`);
      return dev.asset_name === this.selectedAsset && dev.sensorType.toLowerCase() === this.selectedSensorType.toLowerCase();
    });
    this.deviceeui = selectedData ? selectedData.deviceeui : undefined;
    console.log("Selected DeviceEUI:", this.deviceeui);
    this.getMissingTimestamp()
  }

  getMissingTimestamp() {
    let obj = {
      startTime: this.formattedStartTime,
      endTime: this.formattedEndTime,
      deviceeui: this.deviceeui
    }
    this.customerService.getMissingTimestamp(obj).subscribe((res: any) => {
      this.timestamp = res?.data;
      // this.elapsedTimeCount = this.timestamp.map((time) => Math.ceil((time.elapsedTime - 15) / 15))
      // console.log("elapsed time", this.elapsedTimeCount);
    },
      (error) => {
        console.log(error);
      }
    )
  }

  goBack(): void {
    // Navigate to the parent route (typically the customer details or customers list)
    const parentUrl = '/customer/' + this.customer_id;
    console.log("parentUrl", parentUrl);

    this.router.navigateByUrl(parentUrl);
  }
}
